import { Typography } from '@material-ui/core'
import { useHistory } from 'react-router'
import {
    Container,
    ConfigurationItem,
    ConfigurationItemContainer
} from './styles'
import { GrGroup, GrUser } from 'react-icons/gr'
import { IoIosHome, IoIosPeople, IoIosPerson } from 'react-icons/io'

export default function Settings() {

    const history = useHistory()

    return (
        <Container>
            <Typography variant="h4" style={{ marginBottom: 30, fontWeight: 600 }}>
                Configurações do sistema
            </Typography>
            <ConfigurationItemContainer>
                <ConfigurationItem onClick={() => { history.push('/settings/users') }}>
                    Usuários
                    <IoIosPerson size={80} style={{ marginTop: 15 }} />
                </ConfigurationItem>
                <ConfigurationItem onClick={() => { history.push('/settings/permission') }}>
                    Grupos
                    <IoIosPeople size={100} style={{ marginTop: 15 }} />
                </ConfigurationItem>

                <ConfigurationItem onClick={() => { history.push('/settings/branchs') }}>
                    Agências
                    <IoIosHome size={80} style={{ marginTop: 15 }} />
                </ConfigurationItem>
            </ConfigurationItemContainer>
        </Container>
    )
}